export default __webpack_public_path__ + "static/kelly@2x-4e6411b898876ba845620c4f32ee8c11.jpg";